





import { Component, Prop, Vue } from 'vue-property-decorator';
import VideoPlayer from '@/video/player/components/VideoPlayer.vue';
import type { IVideo } from '@signing-page/documents/types/video';

@Component({
  components: {
    VideoPlayer,
  },
})
export default class VideoReminder extends Vue {
  @Prop() video!: IVideo;

  handleClose() {
    this.$emit('close');
  }
}
